import { Component, input, output, inject, effect, model, computed } from '@angular/core';
import { I18nService } from '../../services/i18n.service';
import { GLOBAL_CONSTANT } from '../../constants/global.constant';
import { SafeSelectComponent, SafeSelectOption } from '../safe-select/safe-select';

@Component({
  selector: 'app-select',
  imports: [SafeSelectComponent],
  templateUrl: './selectComponent.html',
  styleUrls: ['./selectComponent.scss'],
})
export class SelectComponent {
  optional = input<boolean>(false);
  disabled = input<boolean>(false);
  placeholder = input<string>(GLOBAL_CONSTANT.EMPTY_STRING);
  options = input<string[]>([]);
  selected = model<string>(GLOBAL_CONSTANT.EMPTY_STRING);

  selectedChange = output<string>();

  i18n = inject(I18nService);

  safeOptions = computed<SafeSelectOption[]>(() =>
    this.options()
      .map((v) => ({ label: this.i18n.parse(v), value: v }))
      .sort((a, b) => a.label.localeCompare(b.label))
  );

  constructor() {
    effect(() => {
      if (!this.selected()) {
        this.selected.set(this.placeholder());
      }
    });
  }

  onChange(value: any) {
    this.selectedChange.emit(value);
    this.selected.set(value);
  }
}
